export const CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS = 'CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS';
export const HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS = 'HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS';
